export default __webpack_public_path__ + "static/media/ui_store_experience_banner_03.2ac70fc8.png";